import React, { Component } from 'react';
// import ReactCSSTransitionReplace from 'react-css-transition-replace';

// import PropTypes from 'prop-types';
import Animals from './Animals';
import Details from './Details';
import AnimalData from '../../data/Animals';
// import styles from './CarouselWrapper.styl';

class CarouselWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSlide: 1
    };

    this.setSelectedSlide = this.setSelectedSlide.bind(this);
  }

  setSelectedSlide = i => {
    this.setState({
      selectedSlide: i
    });
  };

  componentDidMount = () => {
    AnimalData.map((animal, i) => {
      let img = new Image();
      return (img.src = animal.image);
    });
  };

  render() {
    return (
      <div style={{ position: 'relative', marginBottom: '15vh' }} id="animal-section">
        <Animals setSelectedSlide={this.setSelectedSlide} scrollToAnimals={this.props.scrollToAnimals}/>
        <Details
          animal={AnimalData[this.state.selectedSlide]}
          key={this.state.selectedSlide}
        />
      </div>
    );
  }
}

export default CarouselWrapper;



// WEBPACK FOOTER //
// ./src/components/carousel/CarouselWrapper.js